import { AppBar, Box, Paper, Typography } from "@mui/material";
import CheckBoxCustom from "../../../../../components/checkbox/CheckBoxCustom";
import React from "react";
import moment from "moment";
import { useTranslation } from "react-i18next";


type boxContentProps = {
    heading: string;
    data: {
        qty: number;
        name: string;
        id: number | string;
    }[];
    date?: string | Date;
    custom_component?: React.ReactNode;
    height?: React.CSSProperties['height'];
    disabled_scroll?: boolean;
    disabled_heading?: boolean;
    heading_center?: string;
    textAlignHeading?: React.CSSProperties['textAlign'];
    check_data?: any[];
    onCheckData?: (data: any) => void;
    onCheckAll?: (id: any[]) => void;
}
export const BoxContentRendering = (props: boxContentProps) => {
    const { t } = useTranslation();

    const allIds:any[] = props.data.filter(x => x.id).map(x => x.id);
    const checkedIds = props.check_data || [];

    const isAllChecked = allIds.length > 0 && allIds.every(id => checkedIds.includes(id));
    const isIndeterminate = checkedIds.length > 0 && !isAllChecked;



    
    return (
        <Box sx={{
            overflowY: props.disabled_scroll ? 'auto' : props.data.length > 4 ? "scroll" : 'auto',
            // height: props.height ? props.height : 300,
            height: 'auto',
            minHeight: '100%',
            position: 'relative',
            width: '100%'
        }} className="shadow-lg px-5 py-8 rounded-[24px]">
            <section>
                {!props.disabled_heading && (
                    <div className="grid  grid-cols-12">
                        <section className="col-span-6 flex justify-start items-center">
                            <Typography fontSize={20} fontWeight={700}>
                                {props.heading}
                            </Typography>
                        </section>
                        <section className="col-span-6 flex justify-end items-center">
                            <Typography fontSize={20} fontWeight={700}>
                                {t("จำนวน")}
                            </Typography>
                        </section>
                    </div>
                )}
                {props.heading_center && (
                    <Typography my={2} textAlign={props.textAlignHeading || 'center'} fontSize={20} fontWeight={700}>
                        {props.heading_center}
                    </Typography>
                )}
                {props.date && (
                    <Typography fontSize={14}>
                        {t("ณ วันที่ {{date}}", { date: moment(props.date).format("DD/MM/YYYY") })}
                    </Typography>
                )}
                {props.custom_component ? (
                    <>
                        {props.custom_component}
                    </>
                ) : (
                    <>
                        <section className="col-span-12 mt-4">
                            <CheckBoxCustom
                                label={t('เลือกทั้งหมด')}
                                indeterminate={isIndeterminate}
                                checked={isAllChecked}
                                setChecked={(checked) =>
                                    props.onCheckAll?.(checked ? allIds : [])
                                }
                            />
                        </section>
                        <section className="grid grid-cols-12">
                            {props.data?.map((list) => {
                                return (
                                    <React.Fragment key={list.id}>
                                        <article className="col-span-8 flex flex-1 justify-start items-center">
                                            <CheckBoxCustom 
                                                label={list.name}
                                                disabled={!list.id}
                                                checked={props.check_data?.includes(list.id)}
                                                setChecked={() => props?.onCheckData?.(list)}
                                            />
                                        </article>
                                        <article className="col-span-4 flex justify-end items-center">
                                            <Typography>
                                                {list.qty}
                                            </Typography>
                                        </article>
                                    </React.Fragment>
                                )
                            })}
                        </section>
                    </>
                )}

            </section>
        </Box >
    )
}